import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";

const COLORS = ["#A855F7", "#D8B4FE", "#E9D5FF"];

function renderSalesByBranchLabel({ x, y, textAnchor, name, percent }) {
  const words = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  const pct = Number.isFinite(percent) ? `${(percent * 100).toFixed(0)}%` : "";

  return (
    <text
      x={x}
      y={y}
      textAnchor={textAnchor}
      dominantBaseline="central"
      fill="#A855F7"
      style={{ fontSize: 12, fontWeight: 500 }}
    >
      {words.map((w, i) => (
        <tspan key={`${w}-${i}`} x={x} dy={i === 0 ? 0 : 14}>
          {w}
        </tspan>
      ))}
      {pct && (
        <tspan x={x} dy={words.length > 0 ? 14 : 0}>
          {pct}
        </tspan>
      )}
    </text>
  );
}

export default function SalesByBranchSection({ styles, salesByBranchData, salesByBranchError }) {
  return (
    <div className={styles.chartWithLegendWrapper}>
      <div className={styles.chartSection}>
        <div className={styles.chartHeader}>
          <h3>Sales Performance by Branch</h3>

          <p className={styles.chartSubtitle}>Last 30 days revenue distribution</p>
        </div>
        <div className={styles.chartContainer}>
          {Array.isArray(salesByBranchData) && salesByBranchData.length === 0 ? (
            <div className={styles.emptyStateCenter}>
              <p className="text-gray-500 text-sm text-center">No data available at moment</p>
            </div>
          ) : (
            <ResponsiveContainer width="100%" height={400}>
              <PieChart>
                <Pie
                  data={salesByBranchData}
                  cx="50%"
                  cy="50%"
                  outerRadius={100}
                  fill="#8884d8"
                  dataKey="value"
                  label={renderSalesByBranchLabel}
                >
                  {salesByBranchData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip
                  formatter={(value, _name, props) => [
                    `R${Number(value ?? 0).toFixed(2)}`,
                    props?.payload?.name || "Revenue",
                  ]}
                />
              </PieChart>
            </ResponsiveContainer>
          )}
        </div>
        {salesByBranchError && <p className="text-red-500 text-xs mt-2">{salesByBranchError}</p>}
      </div>

      {Array.isArray(salesByBranchData) && salesByBranchData.length > 0 && (
        <div className={styles.chartLegendSidebar}>
          <h4 className={styles.legendTitle}>Branches</h4>
          <ul className={styles.legendList}>
            {salesByBranchData.map((entry, index) => (
              <li key={entry.name} className={styles.legendItem}>
                <span
                  className={styles.legendColor}
                  style={{ backgroundColor: COLORS[index % COLORS.length] }}
                />
                <span className={styles.legendLabel}>{entry.name}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
